var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAntique = function SvgAntique(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 19h6M10 1a6 6 0 0 0-5.019 9.289c.954 1.452 1.43 2.178 1.492 2.287.551.965.45.624.52 1.733.007.125.007.313.007.69a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1c0-.377 0-.565.008-.69.069-1.109-.033-.768.518-1.733.062-.109.539-.835 1.493-2.287A6 6 0 0 0 10 1"
  })));
};
export { SvgAntique as ReactComponent };
export default __webpack_public_path__ + "728480f0a68cb05fb0c80ccc7660a7ad.svg";